import React from 'react';
import './GIM.css';
import GIMimage from '../Assets/gim1.jpg'; // First image (full size)
import GIMimage2 from '../Assets/gim2.jpg'; // Image for Key Features & Benefits
import GIMimage3 from '../Assets/gim3.jpg'; // Image for How it Works section
import GIMimage4 from '../Assets/gim4.jpg'; // Image for Why Choose section
import GIMimage5 from '../Assets/gim5.jpg'; // Image for Industries section

const GreenInfra = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                <div className="FMS-text">
                    <h1 className="FMS-heading">GREEN INFRASTRUCTURE MANAGEMENT</h1>
                    <p className="FMS-description">
                        Green Infrastructure Management (GIM) focuses on the sustainable planning, implementation, and maintenance of infrastructure systems that leverage natural processes to enhance environmental quality and resilience. GIM solutions aim to reduce carbon footprint, optimize resource usage, and ensure environmental compliance while improving system performance.
                    </p>
                </div>
                <div className="FMS-image-container">
                    <img src={GIMimage} alt="Green Infrastructure" className="FMS-image full-size" />
                </div>
            </div>

            {/* Key Features & Benefits */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            <div className="FMS-content-container">
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Green Infra Management system helps monitor and control energy, water, waste, and air quality metrics. It supports data-driven decisions, smart automation, and alerts to prevent inefficiencies. With cloud-based dashboards and analytics, organizations can ensure compliance and optimize resource usage effectively.
                    </p>
                </div>
                <div className="FMS-image-container">
                    <img src={GIMimage2} alt="GIM Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            <div className="FMS-content-container">
                <div className="FMS-image-container">
                    <img src={GIMimage3} alt="GIM Workflow" className="FMS-image smaller-size" />
                </div>
                <div className="FMS-text">
                    <p className="FMS-description">
                        GIM integrates smart sensors, controllers, and cloud systems to continuously monitor infrastructure assets. Real-time data is analyzed to identify anomalies, optimize performance, and suggest corrective actions. Automation rules can be applied to ensure environmental compliance and reduce operational overhead.
                    </p>
                </div>
            </div>

            {/* Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Green Infra Management</h2>
            </div>

            <div className="FMS-content-container">
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our solution ensures sustainability and cost efficiency through advanced data analytics and real-time monitoring. It empowers organizations to meet green goals while maintaining operational integrity:
                        <ul>
                            <li>Comprehensive environmental monitoring</li>
                            <li>Seamless integration with existing systems</li>
                            <li>Proactive maintenance with alerts</li>
                            <li>Compliance with green standards and policies</li>
                            <li>Custom dashboards and intelligent insights</li>
                        </ul>
                    </p>
                </div>
                <div className="FMS-image-container">
                    <img src={GIMimage4} alt="Why Choose GIM" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Industries Using GIM */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our GIM</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                <div className="FMS-image-container">
                    <img src={GIMimage5} alt="Industries GIM" className="FMS-image smaller-size" />
                </div>
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Green Infra Management solution is applied across various industries seeking sustainable operations:
                        <ul>
                            <li>Smart Cities</li>
                            <li>Industrial Parks</li>
                            <li>Public Infrastructure</li>
                            <li>Commercial Real Estate</li>
                            <li>Utilities & Energy</li>
                            <li>Transport & Logistics</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default GreenInfra;
